// Constantes uniques du site (lien, contact, lieu). À réutiliser partout plutôt que de les recopier.
export const SITE_URL = 'https://kuba-studio.com';
export const EMAIL = 'contact@kuba-studio.com';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/kuba-studio/';
export const REGION = 'Île-de-France';
export const LOGO_URL = `${SITE_URL}/logo-kuba-studio-blanc.png`;
export const OG_IMAGE = '/og-image.png';
